import React, { ChangeEvent } from "react";
import classnames from "classnames";
import { SelectFilterOptionGroup } from "/web/types/universal-filters";
import { StandardFilterProps } from "/web/types/feed-filters";
import styles from "./feeds-filters-drop-down.css";

interface FeedsFiltersDropDownProps extends StandardFilterProps {
    group: SelectFilterOptionGroup;
    className?: string;
}

function FeedsFiltersDropDown({
    group,
    onClick: handleClick,
    pendingFilterInfo,
    className,
}: FeedsFiltersDropDownProps): null | JSX.Element {
    let { id, options, title } = group;

    if (options.length == 0) {
        return null;
    }

    let selected = options.find((option) => pendingFilterInfo.getChecked(option));
    // all options have the same name
    let nameAttr = options[0].name;

    function onChange(event: ChangeEvent<HTMLSelectElement>): void {
        let target = options.find((option) => option.value == event.target.value);
        if (target) {
            handleClick(target);
        }
    }

    return (
        <div className={classnames(styles.wrapper, className)}>
            <strong className={styles.label}>{title}</strong>
            <div className={styles.dropDown}>
                <select
                    id={id}
                    className={styles.select}
                    name={nameAttr}
                    value={(selected && selected.value) || ""}
                    onChange={onChange}
                >
                    {options.map((option) => (
                        <option value={option.value} key={option.value}>
                            {option.label}
                        </option>
                    ))}
                </select>
            </div>
        </div>
    );
}

export default FeedsFiltersDropDown;
